module.exports = import("fs/promises");;